/*
 * @Author: caiqin.xie
 * @since: 2023-06-29 15:49:13
 * @lastTime: 2023-11-09 16:49:43
 * @LastEditors: caiqin.xie
 * @message: 门店组件-门店图片轮播
 */
import React from "react";
import { Carousel } from '@arco-design/web-react';
import { getFileExtension } from '@/common/untils'
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia";
import { IShop } from "@/common/types";
const storeLocation = require('../../assets/support_store_location.png')
const storeTime = require('../../assets/support_store_time.png')
const storePhone = require('../../assets/support_store_phone.png')

interface IProps {
  shop: IShop; // 门店信息
  className?: string;
  carousel: boolean; // 是否展示门店轮播图
}

const CarouselShopItem = (props:IProps) => {
  const {shop, className, carousel} = props;

  return (
    <div className={`${styles["store-item"]} ${className}`} key={shop.id}>
      {carousel && (
        <Carousel
          autoPlay
          showArrow="hover"
          indicatorClassName={styles['carousel-dot']}
          className={styles['swiper']}>
          {shop.images && shop.images.map((item, index) => {
            return (
                <div key={item.id}>
                  {(getFileExtension(item.url) === 'mp4'
                  ? <LazyMedia type="video" LazyClassName='full-wh' className={styles["store-img"]} loop autoPlay preload="auto" playsInline muted src={item.url}/>
                  : <LazyMedia type="image" LazyClassName='full-wh' key={item.id} className={styles["store-img"]} src={item.url} alt={item.alt} />)}
                </div>
            )
          })}
        </Carousel>
      )}
      {!carousel && (
        <div className={styles['swiper']}>
          {shop.images?.length > 0 && (
              <>
                {
                  (getFileExtension(shop.images[0]?.url) === 'mp4'
                    ? <LazyMedia type="video" LazyClassName='full-wh' className={styles["store-img"]} loop autoPlay preload="auto" playsInline muted src={shop.images[0]?.url}/>
                    : <LazyMedia type="image" LazyClassName='full-wh' className={styles["store-img"]} src={shop.images[0]?.url} alt={shop.images[0]?.alt} />)
                }
              </>
          )}
        </div>
      )}
      <div className={styles["store-info-wrap"]}>
        <h3 title={shop?.name}>{shop?.name}</h3>
        {shop.labels && (
          <div className={styles['label-wrap']}>
            {shop.labels.map((item, index) => (
              <span title={item} className={styles['label-item']} key={index}>{item}</span>
            ))}
          </div>
        )}
        <ul className={styles["store-info"]}>
          <li>
            <img src={storeLocation} alt="" />
            <span className={styles['shop-info-content']} title={shop?.detailAddress}>{shop?.detailAddress}</span>
          </li>
          <li>
            <img src={storeTime} alt="" />
            <span className={styles['shop-info-content']} title={shop?.businessHours}>{shop?.businessHours}</span>
          </li>
          <li><img src={storePhone} alt="" />{shop?.phone}</li>
        </ul>
      </div>
    </div>
  )
}

export default CarouselShopItem;
